(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["related-products"]) return;
  try {
    
var loadRelatedProductsIntoSection = function() {
  // Look for an element with class 'related-products'
  var relatedProductsSection = document.querySelector('.related-products');
  if (relatedProductsSection === null) { return; }
  // Create request and submit it using Ajax
  var request = new XMLHttpRequest();
  request.open("GET", relatedProductsSection.dataset.url);
  request.onload = function() {
    if (request.status >= 200 && request.status < 300) {
      var container = document.createElement("div");
      container.innerHTML = request.response;
      relatedProductsSection.innerHTML = container.querySelector('.related-products').innerHTML;
      theme.initAnimateOnScroll();
    }
  };
  request.send();
};
// Fetch when section reloads in editor
document.addEventListener("shopify:section:load", function(event) {
  if (document.querySelector('[data-section-id="' + event.detail.sectionId + '"].related-products')) {
    loadRelatedProductsIntoSection();
  }
});
// Fetch the products on page load
loadRelatedProductsIntoSection();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ss-collection-tabs"] && !Shopify.designMode) return;
  try {
    
function initSurfTabs(root=document){root.querySelectorAll('[data-ss-tabs]').forEach(section=>{if(section.dataset.ready)return;section.dataset.ready='true';const tabs=[...section.querySelectorAll('[role=tab]')];const select=tab=>{tabs.forEach(item=>{const active=item===tab;item.setAttribute('aria-selected',String(active));item.tabIndex=active?0:-1;document.getElementById(item.getAttribute('aria-controls')).hidden=!active;});};tabs.forEach((tab,i)=>{tab.addEventListener('click',()=>select(tab));tab.addEventListener('keydown',event=>{let index;if(event.key==='ArrowRight')index=(i+1)%tabs.length;if(event.key==='ArrowLeft')index=(i-1+tabs.length)%tabs.length;if(event.key==='Home')index=0;if(event.key==='End')index=tabs.length-1;if(index!==undefined){event.preventDefault();select(tabs[index]);tabs[index].focus();}});});});}
document.addEventListener('DOMContentLoaded',()=>initSurfTabs());document.addEventListener('shopify:section:load',()=>initSurfTabs());initSurfTabs();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ss-trustpilot-reviews"] && !Shopify.designMode) return;
  try {
    
if(!customElements.get('ss-review-carousel'))customElements.define('ss-review-carousel',class extends HTMLElement{
connectedCallback(){if(this.ready)return;this.ready=true;this.track=this.querySelector('.ss-reviews-track');this.cards=[...this.querySelectorAll('.ss-review-card')];this.dots=[...this.querySelectorAll('[data-slide]')];this.controls=this.querySelector('.ss-reviews-controls');this.prev=this.querySelector('[data-direction="-1"]');this.next=this.querySelector('[data-direction="1"]');this.querySelectorAll('[data-direction]').forEach(b=>b.addEventListener('click',()=>this.go(this.index+Number(b.dataset.direction))));this.dots.forEach(b=>b.addEventListener('click',()=>this.go(Number(b.dataset.slide))));this.track.addEventListener('scroll',()=>this.update(),{passive:true});this.track.addEventListener('keydown',e=>{if(e.target!==this.track)return;if(e.key==='ArrowRight'||e.key==='ArrowLeft'){e.preventDefault();this.go(this.index+(e.key==='ArrowRight'?1:-1));}});this.onSelect=e=>{const i=this.cards.indexOf(e.target.closest('.ss-review-card'));if(i>=0)this.go(i);};this.addEventListener('shopify:block:select',this.onSelect);this.observer=new ResizeObserver(()=>this.update());this.observer.observe(this.track);this.update();}
disconnectedCallback(){this.observer?.disconnect();}
positions(){const first=this.cards[0];if(!first)return[];const max=this.track.scrollWidth-this.track.clientWidth;return this.cards.map(c=>Math.min(max,c.offsetLeft-first.offsetLeft));}
update(){const positions=this.positions();const unique=[...new Set(positions.map(p=>Math.round(p)))];this.positionsList=unique;this.index=unique.reduce((best,p,i)=>Math.abs(p-this.track.scrollLeft)<Math.abs(unique[best]-this.track.scrollLeft)?i:best,0);this.controls.hidden=unique.length<2;this.prev.disabled=this.index===0;this.next.disabled=this.index===unique.length-1;this.dots.forEach((b,i)=>{b.hidden=i>=unique.length;b.setAttribute('aria-current',String(i===this.index));});}
go(index){this.update();const i=Math.max(0,Math.min(index,this.positionsList.length-1));this.track.scrollTo({left:this.positionsList[i],behavior:matchMedia('(prefers-reduced-motion:reduce)').matches?'auto':'smooth'});}
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ss-winter-offers"] && !Shopify.designMode) return;
  try {
    
if(!customElements.get('ss-winter-offers'))customElements.define('ss-winter-offers',class extends HTMLElement{
 connectedCallback(){if(this.ready)return;this.ready=true;const track=this.querySelector('ul');const buttons=this.querySelectorAll('button');const update=()=>{buttons[0].disabled=track.scrollLeft<2;buttons[1].disabled=track.scrollLeft+track.clientWidth>=track.scrollWidth-2;};buttons.forEach(button=>button.addEventListener('click',()=>track.scrollBy({left:Number(button.dataset.direction)*(track.firstElementChild.getBoundingClientRect().width+parseFloat(getComputedStyle(track).gap)),behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'instant':'smooth'})));track.addEventListener('scroll',update,{passive:true});this.observer=new ResizeObserver(update);this.observer.observe(track);update();}
 disconnectedCallback(){this.observer?.disconnect();this.ready=false;}
});

  } catch(e) { console.error(e); }
})();
})();
